{
  "title": "Mailboxes",
  "subtitle": "Mailboxes mirrored from the directory, and the signature each one gets.",
  "listIntro": "Mirrored from the customer's directory. People appear here automatically within about fifteen minutes of being created in Microsoft 365.",
  "searchPlaceholder": "Search name or address",
  "defaultTemplate": "Default signature",
  "defaultIntro": "Applied to every mailbox that does not have something more specific. Operator rules and group signatures override it; a signature set on one person here overrides both.",
  "noPublishedTemplates": "No published templates yet. Publish one on the Signatures tab and it can become the tenant default.",
  "newMessages": "New messages",
  "noDefault": "No default set",
  "repliesForwards": "Replies and forwards",
  "sameAsNew": "Same as new messages",
  "saveDefault": "Save default",
  "defaultCleared": "Default cleared. Mailboxes following it are no longer stamped.",
  "defaultSaved": "Default saved and applied to every mailbox.",
  "saveFailed": "Could not save that.",
  "noMailboxesCovered": "No mailboxes are covered yet.",
  "coveredCount": "{{count}} mailbox covered.",
  "coveredCount_other": "{{count}} mailboxes covered.",
  "coveredWithCustom": "{{covered}} mailboxes covered, {{custom}} with a signature set individually.",
  "setDefault": "Set default",
  "colPerson": "Person",
  "colSignature": "Signature",
  "colNewMessages": "New messages",
  "colRepliesForwards": "Replies & forwards",
  "previewNewAria": "Preview new-message signature {{name}}",
  "previewReplyAria": "Preview reply signature {{name}}",
  "colStamped": "Stamped",
  "colSidebar": "Sidebar",
  "colAllowChanges": "Allow changes",
  "colExcluded": "Excluded",
  "selectAllVisible": "Select all visible mailboxes",
  "selectUser": "Select {{email}}",
  "emptySearch": "Nobody matches that search.",
  "emptyNone": "No mailboxes have synced yet. Connect a directory on the Settings tab.",
  "showingFirst200": "Showing the first 200. Search to narrow the list.",
  "addressesCount": "{{count}} addresses",
  "noMailbox": "No mailbox",
  "stateCustomised": "Customised",
  "stateDefault": "Default",
  "stateNotCovered": "Not covered",
  "stateCustom": "Custom",
  "stateExcluded": "Excluded",
  "stateRule": "From rule",
  "stateGroup": "From group",
  "previewAria": "Preview signature {{name}}",
  "stampAria": "Stamp mail from {{email}}",
  "sidebarAria": "Offer Outlook sidebar for {{email}}",
  "sidebarTitle": "Offer the Outlook signature pane for this person",
  "allowChangesAria": "Allow signature changes for {{email}}",
  "allowChangesTitle": "Let them pick a signature and edit fields in Outlook",
  "changeFailed": "Could not change that.",
  "preview": "Preview",
  "whyThis": "Why this?",
  "fields": "Fields",
  "customise": "Customise",
  "revert": "Revert",
  "revertedToDefault": "{{name}} is back on the tenant default.",
  "unknownTemplate": "Unknown template",
  "signatureFallback": "Signature",
  "massUpdate": "Mass update",
  "massUpdateCount": "Mass update ({{count}})",
  "selectedCount": "{{count}} selected",
  "massUpdateTitle": "Mass update",
  "massUpdateIntro": "Apply one change to {{count}} selected mailbox.",
  "massUpdateIntro_other": "Apply one change to {{count}} selected mailboxes.",
  "action": "Action",
  "actionPlaceholder": "Choose what to change",
  "actionStamp": "Stamp (include in signatures)",
  "actionUnstamp": "Unstamp (exclude from signatures)",
  "actionCustomise": "Customise signature",
  "actionRevert": "Revert to tenant default",
  "actionSidebarOn": "Outlook sidebar: enable",
  "actionSidebarOff": "Outlook sidebar: disable",
  "actionAllowOn": "Outlook: allow changes",
  "actionAllowOff": "Outlook: lock settings (preview only)",
  "signature": "Signature",
  "choosePublished": "Choose a published template",
  "skippedNoMailbox": "{{count}} without a mailbox will be skipped.",
  "skippedNotCustomised": "{{count}} not customised will be skipped.",
  "nobodyEligible": "Nobody in the selection can take that change.",
  "apply": "Apply",
  "updatedCount": "Updated {{count}} mailbox.",
  "updatedCount_other": "Updated {{count}} mailboxes.",
  "failedCount": "Could not update {{count}} mailbox.",
  "failedCount_other": "Could not update {{count}} mailboxes.",
  "partialUpdate": "Updated {{succeeded}}, failed on {{failed}}.",
  "massUpdateFailed": "Could not apply that mass update.",
  "customiseTitle": "Signature for {{name}}",
  "customiseIntro": "This pins one mailbox to a signature of its own. It beats group rules and the tenant default, and it stops following the default — including if the default changes later.",
  "setSignature": "Set signature",
  "customiseSuccess": "{{name}} now has their own signature.",
  "customiseFailed": "Could not set that signature.",
  "explainTitle": "Signature for {{name}}",
  "explainIntro": "Runs the same evaluation the mail path runs, against a new message to an external recipient.",
  "explain": "Explain",
  "explainFailedTitle": "Could not run the test",
  "fieldsTitle": "Fields — {{name}}",
  "fieldsSaved": "Field overrides saved.",
  "fieldsSaveFailed": "Could not save.",
  "photoAria": "Photo for {{email}}",
  "photoUploaded": "Uploaded photo",
  "photoFromDirectory": "From the directory",
  "uploadPhoto": "Upload a photo",
  "replacePhoto": "Replace photo",
  "clearPhoto": "Clear photo",
  "removeUseDirectory": "Remove and use the directory's",
  "photoRemoved": "Photo removed. The next directory sync will bring theirs back if they have one.",
  "photoNotRemovedTitle": "Not removed",
  "photoNotRemoved": "Could not remove that photo.",
  "photoUpdated": "Photo updated.",
  "photoUpdatedTitle": "Photo updated",
  "photoNotUploadedTitle": "Not uploaded",
  "photoNotUploaded": "Could not upload that photo.",
  "photo": "Photo",
  "exclude": "Exclude from stamping",
  "include": "Include in stamping",
  "editFields": "Edit fields",
  "outlookSetup": "Outlook add-in setup",
  "outlook": {
    "cardTitle": "Outlook sidebar add-in",
    "cardIntro": "Deploy the add-in once via Microsoft 365 Centralized Deployment, then enable it per mailbox on the Users tab. Defaults below apply only to newly synced mailboxes.",
    "setupWizard": "Setup wizard",
    "sidebarDefault": "Enable sidebar for new mailboxes",
    "allowDefault": "Allow self-service changes for new mailboxes",
    "editableFields": "Fields end users may edit",
    "editableFieldsDesc": "e.g. mobile, title. Identity fields are never editable.",
    "fieldPlaceholder": "Add a merge field key",
    "manifestUrl": "Manifest URL",
    "manifestCopied": "Manifest URL copied.",
    "save": "Save Outlook settings",
    "saved": "Outlook sidebar settings saved.",
    "saveFailed": "Could not save.",
    "gateNote": "Per-mailbox Sidebar / Allow changes switches on the Users tab gate access after deploy.",
    "wizardTitle": "Deploy Outlook signature add-in",
    "wizardIntro": "Centralized Deployment installs the add-in for assigned Microsoft 365 users. After that, turn on Sidebar (and optionally Allow changes) per mailbox on the Users tab — deployment alone does not open settings for everyone.",
    "stepPrereq": "Prerequisites",
    "stepManifest": "Manifest URL",
    "stepUpload": "Upload in admin center",
    "stepAssign": "Assign users",
    "stepEnable": "Enable mailboxes",
    "stepVerify": "Verify in Outlook",
    "completeTitle": "Deployment checklist complete",
    "completeBody": "Users may need to restart Outlook. The ribbon button can take up to a few hours to appear for everyone. If the pane says the organisation has not enabled Signature settings, flip Sidebar on for that mailbox on Users.",
    "finish": "Finish",
    "beforeStart": "Before you start",
    "prereqAdmin": "Sign in to the Microsoft 365 admin center as a Global Administrator or Office Apps Administrator.",
    "prereqOutlook": "Users need Exchange Online / Microsoft 365 Outlook (classic perpetual Outlook is not supported for this add-in).",
    "prereqHttps": "The add-in only XML manifest is hosted over HTTPS by OnBrandMail — paste the URL; you do not upload a file from disk.",
    "copyManifestTitle": "Copy the manifest URL",
    "copyManifestBody": "Microsoft validates this XML link when you deploy. Keep it on HTTPS and do not rewrite the path (it must end in manifest.xml).",
    "uploadTitle": "Upload in the Microsoft 365 admin center",
    "uploadStep1": "Open Settings → Integrated apps in the admin center.",
    "uploadStep2": "Choose Upload custom apps (or Deploy Add-in if you are on the Add-ins page).",
    "uploadStep3": "Set App type to Office Add-in (not Teams app).",
    "uploadStep4": "Select Provide link to manifest file, paste the XML URL from the previous step, then Validate / Upload.",
    "uploadStep5": "Accept the permission requests when prompted so Outlook can open the signature pane.",
    "openIntegratedApps": "Open Integrated apps",
    "pilotHint": "Prefer a pilot security group first (same people you use for mail-flow pilot). You can widen assignment later without re-uploading the manifest.",
    "assignTitle": "Who receives the add-in",
    "assignIntro": "Assignment here only installs the Outlook button. It does not grant signature self-service — that stays on the Users tab.",
    "assignSpecific": "Specific users/groups — recommended. Start with your OnBrandMail pilot group.",
    "assignEveryone": "Everyone — fine once you are ready; the pane still shows an empty state until Sidebar is enabled for that mailbox.",
    "assignJustMe": "Just me — useful to validate the ribbon before widening the rollout.",
    "assignDeploy": "Select Deploy / Finish deployment when the wizard asks. Microsoft may take minutes to hours before the button appears for every assignee.",
    "enableTitle": "Enable mailboxes in OnBrandMail",
    "enableIntro": "Centralized Deployment is org-scoped; OnBrandMail gates the experience per person.",
    "enableStep1": "Open the Users tab for this tenant.",
    "enableStep2": "Turn on Sidebar for each pilot mailbox (or use Mass update → Outlook sidebar: enable).",
    "enableStep3": "Optionally turn on Allow changes so those people can pick a template and edit governed fields. Leave it off for preview-only.",
    "enableStep4": "Tenant administrators always get the elevated pane for their own mailbox, even if Sidebar is off.",
    "enableDefaultsNote": "Defaults on this Settings card only apply to newly synced mailboxes. Existing people need the Users switches (or mass update).",
    "verifyTitle": "Verify in Outlook",
    "verifyStep1": "Restart the new Outlook / Outlook on the web for a pilot user.",
    "verifyStep2": "Open a message or compose window and look for the Signature button on the ribbon.",
    "verifyStep3": "The pane should show their preview and “why this signature”. If it asks them to sign in, they must use the Sign in button in the pane — Outlook does not share a session from a normal browser. If settings are locked, that is expected when Allow changes is off.",
    "verifyStep4": "As a tenant admin, confirm the admin strip and mailbox lookup appear when you open the pane yourself.",
    "verifyManifestHint": "If validation of the manifest URL fails in the admin center, confirm the URL returns XML (OfficeApp) over HTTPS from a browser outside your network.",
    "theUrl": "the URL"
  }
}
